type TamFitsInZoneProps = {
  textbox: fabric.Textbox;
  photoTextZone: fabric.Group;
};

export const tamFitsInZone = ({ textbox, photoTextZone }: TamFitsInZoneProps): boolean => {
  const height = textbox.getScaledHeight();
  const width = textbox.getScaledWidth();
  return height <= photoTextZone.getScaledHeight() && width <= photoTextZone.getScaledWidth();
};
